import React, { useCallback } from "react";

import { socket } from "../../../../lib/socketio";
import { GroupTemplate } from "../../../Definitions/cl";
import { Grid, Segment } from "semantic-ui-react";
import ActivateOverride from "../../../Macros/ActivateOverride";
import ClearOverride from "../../../Macros/ClearOverride";
import TBIOColumn from "../../../Monitor/Data/TBIOColumn";
import Footer from "../../Footer";

import ConfirmMacro from "../../../Macros/ConfirmMacro";
import PCSMacro from "../../../Macros/PCSMacro";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { IO_WRITE, isAuthorized } from "../../../../lib/authorization";

const PCSCommandsOvrPSM1 = ({ write_data }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [ovrdata, setOvrdata] = React.useState([]);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [isCopied, setIsCopied] = React.useState(false);
  // for digital Override
  const [dataCopy, setDataCopy] = React.useState();

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 98 }, { display_id: 67 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
        setIsCopied(false); //for digital overrides
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const FooterTags = tags.flatMap((t) => (t.display_id === 67 ? [t] : []));

  const GenTags = tags.flatMap((t) =>
    // t.page_name === 'HRM Analog I/O Override' ? [t] : []);
    t.display_id === 98 ? [t] : [],
  );

  const display = GenTags.map((t) => t.page_name);

  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");
  const ClearIds = Object.keys(GroupTags[0]).map((i) =>
    GroupTags[0][i].map((r) => r.id),
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const parentcallback = useCallback((flag) => {
    if (flag === true) {
      setOvrdata([]);
      settags([]);
      setDataCopy({});
    }
  }, []);

  const rows = 1;
  const columns = [];
  const length = GroupTags[0].length;
  let i = 0;
  while (i < length) {
    columns.push(GroupTags[0].slice(i, i + rows));
    i += rows;
  }

  const convertValue = (value, name) => {
    if (typeof value === "undefined") {
      return "";
    } else {
      if (value === 1) {
        return "ON";
      } else {
        return "OFF";
      }
    }
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={{ marginTop: "0px" }}>{display[0]}</h1>

      {/* <div style={styles.menu}>
                <ClearOverride
                    tagid={ClearIds[0]}
                    tags={tags}
                    settags={settags}
                    option={1}
                    channel={'Clear All PSM1 PCS Digital Overrides'}
                    settempovrdata={settempovrdata}
                    settempoverriden={settempoverriden}
                    parentCallback={parentcallback}
                />
                <ActivateOverride
                    ovrdata={ovrdata}
                    tags={tags}
                    settags={settags}
                    channel={'Activate All PSM1 PCS Digital Overrides'}
                    parentCallback={parentcallback}
                    settempovrdata={settempovrdata}
                    tempoverridden={tempoverridden}
                    settempoverriden={settempoverriden}
                />
            </div> */}
      <Grid columns={8} centered celled="internally" stackable padded>
        {(electronApp || isAuthorized(user.hmi_role, IO_WRITE)) && (
          <Grid.Row>
            <Grid.Column style={styles.button}>
              <ConfirmMacro option={2} channel={"PSM1 PCS RUN CMD"} />
              <p>{convertValue(data[9650])}</p>
            </Grid.Column>
            <Grid.Column style={styles.button}>
              <ConfirmMacro option={2} channel={"PSM1 PCS SHUTDOWN CMD"} />
              <p>{convertValue(data[9651])}</p>
            </Grid.Column>
            <Grid.Column style={styles.button}>
              <ConfirmMacro option={2} channel={"PSM1 PCS FAULTRESET CMD"} />
              <p>{convertValue(data[30586])}</p>
            </Grid.Column>
            <Grid.Column style={styles.button}>
              <ConfirmMacro option={2} channel={"PSM1 PCS STANDBY CMD"} />
              <p>{convertValue(data[9649])}</p>
            </Grid.Column>

            {/* 
                    <Grid.Column style={styles.button}>
                        <PCSMacro
                            title = {'PCS RUN PSM1'}
                            channel = {'PSM1 PCS RUN CMD'}
                            option ={1}
                            description = {'Do you wish to RUN PCS (PSM1)?'}/>
                        <p>{convertValue(data[12408])}</p>
                    </Grid.Column>
                    <Grid.Column style={styles.button}>
                        <PCSMacro
                            title = {'PCS SHUTDOWN PSM1'}
                            channel = {'PSM1 PCS SHUTDOWN CMD'}
                            option ={1}
                            description = {'Do you wish to SHUTDOWN PCS (PSM1)?'}/>
                        <p>{convertValue(data[12409])}</p>
                    </Grid.Column>
                    <Grid.Column style={styles.button}>
                        <PCSMacro
                            title = {'PCS RESETFAULTS PSM1'}
                            channel = {'PSM1 PCS RESETFAULT CMD'}
                            option ={1}
                            description = {'Do you wish to Reset PCS Faults (PSM1)?'}/>
                        <p>{convertValue(data[12792])}</p>
                    </Grid.Column>
                    <Grid.Column style={styles.button}>
                        <PCSMacro
                            title = {'PCS STANDBY PSM1'}
                            channel = {'PSM1 PCS STANDBY CMD'}
                            option ={1}
                            description = {'Do you wish to STANDBY PCS (PSM1)?'}/>
                        <p>{convertValue(data[12407])}</p>
                    </Grid.Column> */}
          </Grid.Row>
        )}
      </Grid>

      {/* <Grid>
                <Grid.Row>
                    <Grid.Column inverted divided centered columns='equal' style={styles.grid}>
                        {columns.map((c, i) => (
                            <TBIOColumn
                                key={i}
                                index={i}
                                column={c}
                                data={data}
                                title={'PSM1 PCS Digital Overrides'}
                                ovrdata={ovrdata}
                                tags={tags}
                                settags={settags}
                                tempovrdata={tempovrdata}
                                settempovrdata={settempovrdata}
                                tempoverridden={tempoverridden}
                                settempoverriden={settempoverriden}
                                setIsCopied={setIsCopied}
                                dataCopy={dataCopy}
                                setDataCopy={setDataCopy}
                            />
                        ))}
                    </Grid.Column>
                </Grid.Row>
            </Grid> */}

      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  toggle: {
    marginTop: "20px",
    marginBottom: "30px",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    marginBottom: "20px",
  },
  grid: {
    marginTop: "10px",
    paddingBottom: "0",
  },
  button: {
    textAlign: "center",
  },
};

export default PCSCommandsOvrPSM1;
